


















import { Component, Vue, Prop } from 'vue-property-decorator';
import PrivateLink from '@/components/parts/catalog/list/item/components/Link.vue';
import { MoreButton, Badge } from './components';
import { RawLocation, Image, ICompetencesCard } from './types';
import { AppPicture, AppHeading } from '@/uikit';

@Component({
  components: { PrivateLink, MoreButton, Badge, AppPicture, AppHeading },
})
export default class CompetencesCard extends Vue implements ICompetencesCard {
  @Prop({ type: String, default: '' })
  readonly id: string;

  @Prop({ type: String, default: '' })
  readonly name: string;

  @Prop({ type: Object, default: null })
  readonly image: Image;

  @Prop({ type: Number, default: '' })
  readonly eventsCount: number;

  @Prop({ type: Number, default: '' })
  readonly professionsCount: number;

  get to(): RawLocation {
    const { id } = this;
    return {
      name: 'competence',
      params: {
        id: String(id),
      },
    };
  }

  get imgStyle(): string {
    return this.image ? this.image.little : '';
  }

  goToCard(): void {
    this.$router.push(this.to);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/competences/card/Card.vue